import {
  getAllCacheRecords,
  init_getAllCacheRecords
} from "./chunk-CO3WWSCI.mjs";
import {
  __esm
} from "./chunk-UYUHCTR5.mjs";

// src/withMemo.ts
var withMemo, withMemo_default;
var init_withMemo = __esm({
  "src/withMemo.ts"() {
    init_getAllCacheRecords();
    withMemo = (originFn, {
      getKey = (arg) => arg,
      getContextKey,
      getCacheStore = () => /* @__PURE__ */ new Map(),
      cacheRejectedPromise = false,
      ttl,
      cacheReplacementPolicy,
      transformArgs = (args) => args
    } = {}) => {
      let nextHitIndex = 1;
      const createSubCache = (previousCache, keyInPreviousCache) => ({
        subCaches: getCacheStore(),
        result: null,
        isCached: false,
        invalidationTimeoutId: null,
        hits: [],
        previousCache,
        keyInPreviousCache
      });
      const rootCache = createSubCache();
      let cacheSize = 0;
      const invalidateByCache = (theCache) => {
        if (theCache.isCached) {
          if (theCache.invalidationTimeoutId) {
            clearTimeout(theCache.invalidationTimeoutId);
          }
          theCache.isCached = false;
          theCache.result = null;
          theCache.invalidationTimeoutId = null;
          theCache.hits = [];
          cacheSize--;
        }
        if (!theCache.previousCache)
          return;
        if (theCache.subCaches.size > 0)
          return;
        theCache.previousCache.subCaches.delete(theCache.keyInPreviousCache);
        if (theCache.previousCache.isCached)
          return;
        invalidateByCache(theCache.previousCache);
      };
      const memoizedFn = function(...args) {
        let currentCache = rootCache;
        if (getContextKey) {
          const cacheKey = getContextKey(this);
          if (!currentCache.subCaches.has(cacheKey)) {
            currentCache.subCaches.set(cacheKey, createSubCache(currentCache, cacheKey));
          }
          currentCache = currentCache.subCaches.get(cacheKey);
        }
        for (const arg of transformArgs(args)) {
          const cacheKey = getKey(arg);
          if (!currentCache.subCaches.has(cacheKey)) {
            currentCache.subCaches.set(cacheKey, createSubCache(currentCache, cacheKey));
          }
          currentCache = currentCache.subCaches.get(cacheKey);
        }
        if (!currentCache.isCached) {
          if (cacheReplacementPolicy) {
            const {
              maxSize,
              strategy
            } = cacheReplacementPolicy;
            if (cacheSize >= maxSize) {
              const allCacheRecords = getAllCacheRecords(rootCache);
              cacheSize = allCacheRecords.length;
              if (cacheSize >= maxSize) {
                const cachesToReplace = strategy(allCacheRecords);
                cachesToReplace.forEach(invalidateByCache);
              }
            }
          }
          currentCache.result = originFn.call(this, ...args);
          currentCache.isCached = true;
          if (ttl != null) {
            currentCache.invalidationTimeoutId = setTimeout(
              () => invalidateByCache(currentCache),
              ttl
            );
          }
          cacheSize++;
        }
        currentCache.hits.push({
          index: nextHitIndex++,
          timestamp: +/* @__PURE__ */ new Date()
        });
        if (!cacheRejectedPromise) {
          Promise.resolve(currentCache.result).catch(
            () => invalidateByCache(currentCache)
          );
        }
        return currentCache.result;
      };
      memoizedFn.invalidateCache = () => {
        if (ttl != null) {
          getAllCacheRecords(rootCache).forEach((cacheData) => {
            if (cacheData.invalidationTimeoutId) {
              clearTimeout(cacheData.invalidationTimeoutId);
            }
          });
        }
        cacheSize = 0;
        Object.assign(rootCache, createSubCache());
      };
      memoizedFn.invalidateCacheByArgs = (...args) => {
        if (getContextKey)
          throw new Error("Use invalidateCacheByContextAndArgs instead");
        let currentCache = rootCache;
        for (const arg of transformArgs(args)) {
          const cacheKey = getKey(arg);
          currentCache = currentCache.subCaches.get(cacheKey);
          if (!currentCache)
            return;
        }
        invalidateByCache(currentCache);
      };
      memoizedFn.invalidateCacheByContextAndArgs = (context, ...args) => {
        if (!getContextKey)
          throw new Error("Use invalidateCacheByArgs instead");
        let currentCache = rootCache;
        const cotextKey = getContextKey(context);
        currentCache = currentCache.subCaches.get(cotextKey);
        if (!currentCache)
          return;
        for (const arg of transformArgs(args)) {
          const cacheKey = getKey(arg);
          currentCache = currentCache.subCaches.get(cacheKey);
          if (!currentCache)
            return;
        }
        invalidateByCache(currentCache);
      };
      return memoizedFn;
    };
    withMemo_default = withMemo;
  }
});

export {
  withMemo,
  withMemo_default,
  init_withMemo
};
